import React from 'react';

class ListItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      propertyNames: this.props.propertyNames,
      properties: [],
      checkStyle: "none"
    }

    this.state.propertyNames.forEach((element, index) => {
      this.state.properties[index] = "";
    });

    let item = this.props.item;

    switch(this.props.listType) {
      case "CampaignBucket":
        this.state.properties[0] = item.name;
        this.state.properties[1] = item.filter_string;
        break;
      case "ConversionAction":
        this.state.properties[0] = item.name;
        this.state.properties[1] = item.conversion_id;
        break;
      default:
        // Just map whatever the object passes in
        // Be very careful with this. It's only an emergency catching mechanism. The order cannot be ensured so saving will get fricked up
        let counter = 0;
        for (let prop in item) {
          if (Object.prototype.hasOwnProperty.call(item, prop) && prop != "id" && prop != "section_id" && prop != "section_type" && prop != "created_at" && prop != "updated_at") {
            this.state.properties[counter] = item[prop];
            counter += 1;
          }
        }
    }

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    let properties = [];
    let inputs = event.target.parentElement.children
    for (let i = 0; i < inputs.length; i++) {
      let input = inputs[i];
      if (input.tagName == "INPUT") {
        properties.push(input.value);
      }
    }

    this.setState({
      properties: properties,
      checkStyle: "inline-block"
    });
  }

  render() {
    const itemRow = this.state.properties.map((property, index) => {
      return (
        <input key={index} className="m-1" type="string" placeholder={this.state.propertyNames[index]} value={this.state.properties[index]} onChange={this.handleInputChange.bind(this)} />
      );
    });
    return (
      <li>
        {itemRow}
        <button name="button" type="button" onClick={() => this.props.removeListItem(this.props.item.id)} style={{ background: "none" }} >
          <i className="fas fa-minus-circle"></i>
        </button>
        <button className="saveChanges" name="button" type="button" onClick={() => {this.props.updateListItem(this.props.item.id, this.state.properties); this.setState({checkStyle: "none"})}} style={{background: "none", display: this.state.checkStyle}} >
          <i className="fas fa-check"></i>
        </button>
      </li>
    );
  }
}

export default ListItem;
